var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SurveyLayout',{attrs:{"dark":false}},[_c('v-skeleton-loader',{staticClass:"mx-auto d-flex flex-column white pa-2",attrs:{"height":"50vh","type":"heading, list-item-three-line, list-item-two-line, text, button"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }